import { doc, getDoc, type Firestore } from "firebase/firestore";

export const getActiveLottery = async (database: Firestore): Promise<string | null> => {
  const snapshot = await getDoc(doc(database, "config", "app"));
  if (!snapshot.exists()) return null;
  const data = snapshot.data();
  if (typeof data.activeLottery !== "string") return null;
  return data.activeLottery;
};
